import React from 'react';
import clsx from 'clsx';
import { Box, Theme, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { trackAttributes } from '../analytics/clickTracker';

const useStyles = makeStyles()((theme: Theme) => ({
    filterCardsContainer: {
        display: 'flex',
        gap: '16px',
        flexWrap: 'wrap',
        marginBottom: theme.spacing(2),
    },

    filterCard: {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        borderRadius: '12px',
        padding: '16px 20px',
        border: `1px solid ${theme.palette.secondary.dark}`,
        background: theme.palette.primary.light,
        minWidth: '180px',
        transition: 'all 0.2s ease',

        '&:hover': {
            borderColor: theme.palette.info.main,
        },
    },

    filterCardActive: {
        background: 'rgba(37, 157, 168, 0.15)',
        borderColor: theme.palette.info.main,
    },
    commonText: {
        color: theme.palette.common.white,
        fontWeight: 500,
        lineHeight: 'normal',
        fontStyle: 'normal',
    },
    fontSize14: {
        fontSize: '14px',
    },
    fontFamilyPoppins: {
        fontFamily: 'Poppins',
    },
    fontSize32: {
        fontSize: '32px',
    },
    fontWeight700: {
        fontWeight: 700,
    },
    textGrayColor: {
        color: theme.palette.common.white,
        opacity: 0.5,
    },
}));

type FilterCardProps = {
    filters: {
        status: string;
        count: number;
        color?: string;
        /** Records clicks on the tile under this id (TRACK in analytics/catalog.ts). */
        trackId?: string;
    }[];
    activeFilter?: string;
    onFilterChange: (filter?: string) => void;
};

const FilterCards: React.FC<FilterCardProps> = ({
    filters,
    activeFilter,
    onFilterChange,
}) => {
    const { classes } = useStyles();

    return (
        <Box className={classes.filterCardsContainer}>
            {filters.map((item) => (
                <Box
                    key={item.status}
                    // selected: whether this click turns the filter on (false: it clears it);
                    // count: the number shown on the tile.
                    {...(item.trackId
                        ? trackAttributes(item.trackId, 'tile', {
                              selected: activeFilter !== item.status,
                              count: item.count,
                          })
                        : {})}
                    onClick={() =>
                        onFilterChange(
                            activeFilter === item.status ? undefined : item.status
                        )
                    }
                    className={clsx(
                        classes.filterCard,
                        activeFilter === item.status && classes.filterCardActive
                    )}
                >
                    <Typography
                        className={clsx(
                            classes.commonText,
                            classes.fontSize14,
                            classes.fontFamilyPoppins,
                        )}
                        pb="4px"
                        
                    >
                        {item.status}
                    </Typography>

                    <Typography
                        className={clsx(
                            classes.commonText,
                            classes.fontSize32,
                            classes.fontFamilyPoppins,
                            classes.fontWeight700
                        )}
                         sx={{ color: `${item.color} !important` }}
                    >
                        {item.count}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export default FilterCards;